import { Container, Sprite, Texture } from 'pixi.js';
import { Store, TextureFactory } from '../../core';
import { Vector } from '../../interface';

class PlayerProjectile extends Container {
  public velocity: Vector;
  private isRotatable: boolean;

  constructor() {
    super();

    this.velocity = { x: 0, y: 0 };

    const texture =
      Store.instance.state.costume === 6
        ? Texture.EMPTY
        : TextureFactory.instance.getSingleTexture(
            `/textures/objects/projectile/projectile_${Store.instance.state.costume}.png`
          );
    const sprite = new Sprite(texture);
    sprite.anchor.set(0.5);
    if (Store.instance.state.costume === 0) {
      sprite.scale.set(0.3);
    } else {
      sprite.scale.set(0.65);
    }
    this.addChild(sprite);

    this.isRotatable = [1, 2, 4].includes(Number(Store.instance.state.costume));
  }

  public update(elapsed: number): void {
    this.position.x += this.velocity.x * elapsed;
    this.position.y += this.velocity.y * elapsed;
    if (this.isRotatable) {
      this.rotation += (Math.PI / 10) * elapsed;
    }
  }
}

export default PlayerProjectile;
